import App from 'components/App.jsx';
import Login from 'views/Login';

const indexRoutes = [
        { path: "/login", name: "Pages", component: Login },
        { path: "/", name: "Home", component: App }
];

export default indexRoutes;



// WEBPACK FOOTER //
// ./src/routes/index.jsx